import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import Button from '@atlaskit/button/custom-theme-button';
import { baseAppearanceObj } from '../theme';
import { Action, Actions, Container, ContentContainer, Description, IconWrapper, Title } from './styled';
export default class SectionMessage extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderAction", (action, linkComponent) => {
      const {
        href,
        key,
        onClick,
        text,
        testId
      } = action;
      return /*#__PURE__*/React.createElement(Action, {
        key: key,
        "data-testid": testId
      }, onClick || href ? /*#__PURE__*/React.createElement(Button, {
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined
      }, text) : text);
    });
  }

  render() {
    const {
      children,
      title,
      actions,
      appearance,
      icon,
      linkComponent,
      testId
    } = this.props; //needs typecasting because TS is not recognising default props :(

    const appearanceObj = baseAppearanceObj[appearance] || baseAppearanceObj.info;
    const Icon = icon || appearanceObj.Icon;
    return /*#__PURE__*/React.createElement(Container, {
      backgroundColor: appearanceObj.backgroundColor,
      "data-testid": testId
    }, /*#__PURE__*/React.createElement(IconWrapper, null, /*#__PURE__*/React.createElement(Icon, {
      primaryColor: appearanceObj.primaryIconColor,
      secondaryColor: appearanceObj.backgroundColor
    })), /*#__PURE__*/React.createElement(ContentContainer, null, title ? /*#__PURE__*/React.createElement(Title, null, title) : null, children ? /*#__PURE__*/React.createElement(Description, null, children) : null, actions && actions.length ? /*#__PURE__*/React.createElement(Actions, null, actions.map(action => this.renderAction(action, linkComponent))) : null));
  }

}

_defineProperty(SectionMessage, "defaultProps", {
  appearance: 'info'
});